export const categories = [
  {
    slug: "city",
    label: "城市身边事",
    icon: "ri-building-2-line",
    desc: "街角新开的店、改了规则的路口、悄悄变化的老社区，都值得被记下来。",
    count: 128,
  },
  {
    slug: "consumer",
    label: "消费观察",
    icon: "ri-shopping-bag-3-line",
    desc: "价签、折扣、套路与体验，把真实消费现场分享给同样会买单的人。",
    count: 96,
  },
  {
    slug: "workplace",
    label: "职场见闻",
    icon: "ri-briefcase-line",
    desc: "加班的班车、楼下的店、公司的怪规矩，匿名讲讲打工人的日常。",
    count: 73,
  },
  {
    slug: "campus",
    label: "校园故事",
    icon: "ri-graduation-cap-line",
    desc: "自习室、图书馆、食堂与操场，那些只有学生才懂的细节。",
    count: 64,
  },
  {
    slug: "life",
    label: "生活发现",
    icon: "ri-leaf-line",
    desc: "被忽略的小手艺、被淘汰的老物件，生活里值得被记住的角落。",
    count: 87,
  },
  {
    slug: "trend",
    label: "热点追踪",
    icon: "ri-fire-line",
    desc: "最近大家都在聊什么？把一手线索和亲历现场放上来。",
    count: 152,
  },
];